import { Card, CardBody, Col, Row } from "reactstrap";
import TableContainerMin from "../../../../common/TableContainerMin";
import { Skeleton } from "antd";
const CollaborateursUser = ({columns,data,HeaderTable,isLoading,isError,empty,}) => {
return (  
    <>
     <HeaderTable />
    <Row className="w-100 m-0">
        <Col className="w- p-0">
        <Card className="h-100 w-100" style={{ border: "1px solid #E3E3E3" }}>
        <CardBody className="p-0 ">
        <TableContainerMin
          columns={columns}
          data ={data}
          isGlobalFilter={false}
          customPageSize={10}
          className="custom-header-css"
          divClass="table-responsive "
          tableClass="table w-100 mb-0 no-column-borders"
          theadClass="custom-thead"
          SearchPlaceholder="Recherche..."
          HeaderTable={HeaderTable}
        />
        {isLoading && !isError && (
          <div className="text-center"><Skeleton/> </div>
        )}
        {data && data.length === 0 && !isLoading && (
          <div className="text-center mb-4">
      <img
      src={empty}
      alt="Liste vide"
      style={{ width: "150px", marginBottom: "100px" }}
    />
    </div>
    )}
    </CardBody>
    </Card>
  </Col>
</Row>
</>  
 
);
}
export default CollaborateursUser ;